import AxiosInstance from "./AxiosInstance";

// Get All Destinations
export const getAllVacationBeingHere = async () => {
  try {
    const { data } = await AxiosInstance.get("/vacation_being_here");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Create Destination
export const createVacationBeingHere = async (vacationBeingHere) => {
  try {
    const { data } = await AxiosInstance.post(
      "/vacation_being_here",
      vacationBeingHere
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Update Destination
export const updateVacationBeingHere = async (vacationBeingHere) => {
  try {
    const { data } = await AxiosInstance.put(
      "/vacation_being_here",
      vacationBeingHere
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Delete Destination
export const deleteVacationBeingHere = async (vacationBeingHere) => {
  try {
    const { data } = await AxiosInstance.delete(
      `/vacation_being_here/${vacationBeingHere._id}`
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
